import React from 'react'
import { Chip } from '@mui/material'
import type { FinalMoveOutStatus } from '../../hooks/useMoveOutManagement/useMoveOutManagement'

const FMO_STATUS_LABELS: Record<FinalMoveOutStatus, string> = {
    not_started: 'Not Started',
    pending_inspection: 'Pending Inspection',
    inspection_complete: 'Inspection Complete',
    fmo_sent: 'FMO Sent',
    fmo_reviewed: 'FMO Reviewed',
    fmo_accepted: 'FMO Accepted',
    in_dispute: 'In Dispute',
    final: 'Final',
}

const FIR_STATUS_LABELS: Record<FinalMoveOutStatus, string> = {
    not_started: 'Not Started',
    pending_inspection: 'Pending Inspection',
    inspection_complete: 'Inspection Complete',
    fmo_sent: 'FIR Sent',
    fmo_reviewed: 'FIR Reviewed',
    fmo_accepted: 'FIR Accepted',
    in_dispute: 'In Dispute',
    final: 'Final',
}

export const getStatusLabel = (
    status: FinalMoveOutStatus,
    hasFinancialConnection: boolean,
): string => {
    const labels = hasFinancialConnection ? FMO_STATUS_LABELS : FIR_STATUS_LABELS
    return labels[status] ?? status
}

const STATUS_CHIP_COLORS: Record<
    FinalMoveOutStatus,
    { bgColor: string; textColor: string }
> = {
    not_started: { bgColor: '#e2e8f0', textColor: '#475569' },
    pending_inspection: { bgColor: '#fef3c7', textColor: '#92400e' },
    inspection_complete: { bgColor: '#dbeafe', textColor: '#1e40af' },
    fmo_sent: { bgColor: '#e0e7ff', textColor: '#3730a3' },
    fmo_reviewed: { bgColor: '#e0e7ff', textColor: '#3730a3' },
    fmo_accepted: { bgColor: '#c7d2fe', textColor: '#4338ca' },
    in_dispute: { bgColor: '#fee2e2', textColor: '#991b1b' },
    final: { bgColor: '#d1fae5', textColor: '#065f46' },
}

export const getStatusChip = (
    status: FinalMoveOutStatus,
    hasFinancialConnection: boolean,
) => {
    const label = getStatusLabel(status, hasFinancialConnection)
    const colors = STATUS_CHIP_COLORS[status] ?? {
        bgColor: '#f1f5f9',
        textColor: '#64748b',
    }
    return (
        <Chip
            label={label}
            size="small"
            sx={{
                backgroundColor: colors.bgColor,
                color: colors.textColor,
                fontWeight: 600,
                fontSize: '0.75rem',
            }}
        />
    )
}
